<div class="main row">
  <!-- Add / Edit / Delete Automatic Payment -->
  @if (
    confirmationObj?.category === 'automaticPaymentRule' ||
    confirmationObj?.category === 'multipleAutomaticPaymentRule'
  ) {
    <bill-account-payments-automatic-confirmation [confirmationObj]="confirmationObj">
    </bill-account-payments-automatic-confirmation>
  }

  <!--
  Add Scheduled Payment (single w/ autopay, single w/ out autopay, multi-pay), Edit & Delete Scheduled Payments.
  -->
  @if (confirmationObj?.category === 'scheduledPayments') {
    <ds-billing-payment-confirmation [billingConfirmationData]="confirmationObj">
    </ds-billing-payment-confirmation>
  }

  <!-- Add / Edit / Delete Payment Method -->
  @if (confirmationObj?.category === 'paymentMethod') {
    <ds-billing-payment-confirmation [billingConfirmationData]="confirmationObj">
    </ds-billing-payment-confirmation>
  }

  <!-- Bill Account Registration / Unregistration -->
  @if (confirmationObj?.category === 'billAccount') {
    <ds-bill-account-add-confirmation
      [confirmationObj]="confirmationObj"
      [isMyAccountAdmin]="isMyAccountAdmin"
    >
    </ds-bill-account-add-confirmation>
  }
</div>

<!-- Header Cell required for stacking tables (Requires name, shortName optional) -->
<ng-template #headerCellTpl let-column="column">
  <div class="header-cell table-header-cell-wrapper">
    <span
      [ngClass]="{
        'none lg-block': column?.name && column?.shortName,
        block: column?.name && !column?.shortName
      }"
      >{{ column?.name }}</span
    >
    @if (!!column?.shortName) {
      <span class="block lg-none">{{ column?.shortName }}</span>
    }
  </div>
</ng-template>

<!--
  Account Name only - billAccountNickName or paymentAccountNickName
  THIS IS A HEADER ROW type and requires conditional ds-table-body-cell-header class on mobile
  (Requires account)
  -->
<ng-template #accountNameCellTpl let-row="row">
  @if (!!row) {
    <div class="acct-cell ds-table-body-cell-header-wrapper">
      <div class="block md-none ds-table-body-cell-header">
        <span class="overflow-hidden overflow-ellipsis">
          <span class="margin-0" title="{{ row.account }}">{{ row.account }}</span>
          @if (row.billAccountNumber) {
            <p class="cell-secondary whitespace-nowrap">
              {{ row.billAccountNumber }}
            </p>
          }
        </span>
      </div>
      <div class="none md-block table-body-cell-label-content expandable-cell bordered-cell-first">
        <span class="overflow-hidden overflow-ellipsis">
          <span class="cell" title="{{ row.account }}">{{ row.account }}</span>
          @if (row.billAccountNumber) {
            <p class="cell-secondary whitespace-nowrap">
              {{ row.billAccountNumber }}
            </p>
          }
        </span>
      </div>
    </div>
  }
</ng-template>

<!-- Bill Account Number Template (Requires billAccountNumber) -->
<ng-template #billAccountNumberCellTpl let-row="row">
  @if (!!row) {
    <div>
      <span>
        <div class="flex items-align">
          <h3 class="margin-0" title="{{ row.billAccountNumber }}">
            {{ row.billAccountNumber | prettyBillingAcctNum }}
          </h3>
        </div>
      </span>
    </div>
  }
</ng-template>

<!--
  Policy Description Template (Requires policyDescription array)
  For registering/unregistering an unassociated account we do not have the risk description hence we are
  showing the policy description to the user.
  -->
<ng-template #policyDescriptionCellTpl let-row="row">
  @if (!!row && !!confirmationObj?.policyDescription && !confirmationObj?.riskDescription?.length) {
    <span>
      @for (acc of row.policyDescription; track acc) {
        <span>
          <span class="dueDateCell-amount">{{ acc }}</span>
        </span>
      }
    </span>
  }
</ng-template>

<!-- Risk Description Template (requires riskDescription array) -->
<ng-template #riskDescCellTpl let-row="row">
  @if (!!row) {
    <div>
      @for (risk of row.riskDescription; track risk; let i = $index) {
        <div>
          <div class="dueDateCell-amount">{{ risk | prettyRiskDescription }}</div>
        </div>
      }
    </div>
  }
</ng-template>

<!-- Full Payment Method Widget (requires paymentAccount object from store) -->
<ng-template #paymentAccountCellTpl let-row="row">
  <ds-payment-method-block
    class="cell-component"
    [rowExpanded]="false"
    [useNickNameAsTitle]="row.useNickNameAsTitle"
    [paymentAccount]="row.paymentMethod"
  >
  </ds-payment-method-block>
</ng-template>

<!-- USD Payment amount only (requires paymentAmount) -->
<ng-template #usdPaymentAmountOnlyCellTpl let-row="row">
  @if (!!row) {
    <div class="table-body-cell-label-content expandable-cell bordered-cell-between">
      <span>
        <div class="flex items-align">{{ row?.paymentAmount | currencyUSD }}</div>
      </span>
    </div>
  }
</ng-template>

<!--
  USD Payment amount with subline containing payment date (requires paymentDetails.paymentAmount & paymentDetails.paymentDate)
  -->
<ng-template #usdPaymentAmountWithDateCellTpl let-row="row">
  @if (!!row) {
    <div class="table-body-cell-label-content expandable-cell bordered-cell-between">
      <span>
        <div class="flex items-align">{{ row?.paymentDetails?.paymentAmount | currencyUSD }}</div>
        <div class="dueDateCell">
          <p class="margin-0 cell-secondary">
            {{ row?.paymentDetails?.paymentDate | dateOutFormat: 'MM/DD/YY' }}
          </p>
        </div>
      </span>
    </div>
  }
</ng-template>

<!-- Payment Date only (requires paymentDate) -->
<ng-template #mmddyyyyPaymentDateCellTpl let-row="row">
  @if (!!row) {
    <div>
      <span>
        <div class="flex items-align">{{ row?.paymentDate | dateOutFormat: 'MM/DD/YY' }}</div>
      </span>
    </div>
  }
</ng-template>

<ng-template #relativePaymentDateCellTpl let-row="row">
  @if (!!row) {
    <div>
      <span>
        <div class="flex items-align">
          @if (row?.daysBefore === '0') {
            <span>Paid on due date</span>
          }
          @if (row?.daysBefore === '1') {
            <span>{{ row?.daysBefore }} day before due date</span>
          }
          @if (row?.daysBefore > 1) {
            <span>{{ row?.daysBefore }} days before due date</span>
          }
        </div>
      </span>
    </div>
  }
</ng-template>

<!-- Min Due or Full Pay Only (Requires amount = MinDue or else) -->
<ng-template #minOrFullPaymentAmountOnlyCellTpl let-row="row">
  @if (!!row) {
    <div class="table-body-cell-label-content expandable-cell bordered-cell-between">
      <span>
        <div class="flex items-align">
          @if (row?.amount === 'MINDUE') {
            <span>Minimum Due</span>
          }
          @if (row?.amount !== 'MINDUE') {
            <span>Account Balance</span>
          }
        </div>
      </span>
    </div>
  }
</ng-template>

<!-- Min Due or Full Pay with Days before subline: (Requires amount & daysBefore) -->
<ng-template #minOrFullPaymentAmountWithDaysBeforeCellTpl let-row="row">
  @if (!!row) {
    <div class="table-body-cell-label-content expandable-cell bordered-cell-between">
      @if (
        row?.paymentDetails?.amount !== 'MINDUE' &&
        row?.paymentDetails?.amount !== 'FULLPAY' &&
        row?.paymentDetails?.amount !== 'Minimum Due' &&
        row?.paymentDetails?.amount !== 'Account Balance' &&
        row?.paymentDetails?.amount !== 'Full Pay'
      ) {
        <span>
          <div class="flex items-align">
            <span>{{ row.paymentDetails?.amount | currencyUSD }}</span>
          </div>
          <p class="cell-secondary">
            @if (!!row?.paymentDetails?.nextPaymentDate) {
              <span>{{ row.paymentDetails.nextPaymentDate | dateFormat }}</span>
            }
          </p>
        </span>
      }
      @if (
        row?.paymentDetails?.amount === 'MINDUE' ||
        row?.paymentDetails?.amount === 'FULLPAY' ||
        row?.paymentDetails?.amount === 'Minimum Due' ||
        row?.paymentDetails?.amount === 'Account Balance' ||
        row?.paymentDetails?.amount === 'Full Pay'
      ) {
        <span>
          @if (
            row?.paymentDetails?.amount === 'MINDUE' || row?.paymentDetails?.amount === 'FULLPAY'
          ) {
            <div class="flex items-align">
              @if (row?.paymentDetails?.amount === 'MINDUE') {
                <span>Minimum Due</span>
              }
              @if (row?.paymentDetails?.amount !== 'MINDUE') {
                <span>Account Balance</span>
              }
            </div>
          }
          @if (
            row?.paymentDetails?.amount === 'Minimum Due' ||
            row?.paymentDetails?.amount === 'Account Balance' ||
            row?.paymentDetails?.amount === 'Full Pay'
          ) {
            <div class="flex items-align">
              <span>{{ row.paymentDetails.amount }}</span>
            </div>
          }
          <p class="cell-secondary">
            @if (row?.paymentDetails?.daysBefore === '0') {
              <span>Paid on due date</span>
            }
            @if (row?.paymentDetails?.daysBefore === '1') {
              <span>{{ row?.paymentDetails?.daysBefore }} day before due date</span>
            }
            @if (row?.paymentDetails?.daysBefore > 1) {
              <span>{{ row?.paymentDetails?.daysBefore }} days before due date</span>
            }
          </p>
        </span>
      }
    </div>
  }
</ng-template>

<!-- Confirmation Number Template -->
<ng-template #confirmationNumberCellTpl let-row="row">
  @if (!!row && !!confirmationObj?.paymentConfirmationId) {
    <span>
      {{ row?.confirmationNumber }}
    </span>
  }
</ng-template>

<!-- Status Check Template -->
<ng-template #statusCheckCellTpl let-row="row">
  <div style="width: auto">
    @if (!!row && row.status === 'failure') {
      <span class="icon pseudo-icon icon-alert error-600-text"></span>
    }
    @if (!!row && row.status === 'success') {
      <span class="icon success-400-text icon-complete-circle"></span>
    }
  </div>
</ng-template>
